const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>
  Before:
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `heart`]]), true, false, 3));
                this.echo(`</p>
<p>
  After:
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `heart`], [`inline`, true]]), true, false, 9));
                this.echo(`</p>
`);
            }

            getTemplateName() {
                return `f4c0c5b7a2cdd1620156b64f89629947873fbea1249827ff489c87b065e8e1ef`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f4c0c5b7a2cdd1620156b64f89629947873fbea1249827ff489c87b065e8e1ef`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f4c0c5b7a2cdd1620156b64f89629947873fbea1249827ff489c87b065e8e1ef');

let template = env.loadTemplate('f4c0c5b7a2cdd1620156b64f89629947873fbea1249827ff489c87b065e8e1ef');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/icon/demo/inline.twig", args: context }
     );
     return rendered;;
};